module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/chicken-star2.a71b7cc6.png";